module.exports = __webpack_public_path__ + "img/schnittkante_himmelblau_ral5015.35f81436.jpg";